export default "__VITE_ASSET__B7Pm3XTo__"